import {
  GET_VOUCHER_REQUESTS_LIST_RESPONSE,
  GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE
} from "./types";

const INITIAL_STATE = {
  voucherRequests: {
    list: [],
    meta: {}
  },
  voucherUsedNotUsed: {
    list: [],
    meta: {}
  }
};

const vouchers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_VOUCHER_REQUESTS_LIST_RESPONSE:
      return {
        ...state,
        voucherRequests: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE:
      return {
        ...state,
        voucherUsedNotUsed: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    default:
      return state;
  }
};

export default vouchers;
